import axios from 'axios';

const list = (data) => axios.get('/logist/manState/list', data);
const save = (data) => axios.post('/logist/manState/save', data);
const del = (data) => axios.post('/logist/manState/delete', data); //delete

export default {
  list,
  save,
  del,
}


